import { Globe } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { DropdownMenu, DropdownMenuTrigger, DropdownMenuContent, DropdownMenuItem } from '@/components/ui/dropdown-menu';
import { themesApi } from '@/api/endpoints';

const LANGS = [
  { code: 'pt-BR', label: 'Português (BR)' },
  { code: 'en',    label: 'English' }
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  async function setLang(c: string) {
    i18n.changeLanguage(c);
    try { await themesApi.setPreferences({ language: c }); } catch { /* ignore */ }
  }
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" title="Idioma">
          <Globe className="h-4 w-4" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {LANGS.map(l => (
          <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)}>
            <span className="flex-1">{l.label}</span>
            {i18n.resolvedLanguage === l.code && <span className="text-xs text-muted-foreground">●</span>}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
